__turbopack_context__.v({
  "actions": "bonds-module-scss-module__0QK9YW__actions",
  "bondLayoutWrp": "bonds-module-scss-module__0QK9YW__bondLayoutWrp",
  "bondsLayout": "bonds-module-scss-module__0QK9YW__bondsLayout",
  "buttonsWrp": "bonds-module-scss-module__0QK9YW__buttonsWrp",
  "caption": "bonds-module-scss-module__0QK9YW__caption",
  "card": "bonds-module-scss-module__0QK9YW__card",
  "cardContainer": "bonds-module-scss-module__0QK9YW__cardContainer",
  "cardContainerNoSwadow": "bonds-module-scss-module__0QK9YW__cardContainerNoSwadow",
  "cardContent": "bonds-module-scss-module__0QK9YW__cardContent",
  "cardContentZerocase": "bonds-module-scss-module__0QK9YW__cardContentZerocase",
  "cardHeader": "bonds-module-scss-module__0QK9YW__cardHeader",
  "cardHeaderActions": "bonds-module-scss-module__0QK9YW__cardHeaderActions",
  "cardHeaderTitle": "bonds-module-scss-module__0QK9YW__cardHeaderTitle",
  "cardHeaderTitleBrackets": "bonds-module-scss-module__0QK9YW__cardHeaderTitleBrackets",
  "cardInner": "bonds-module-scss-module__0QK9YW__cardInner",
  "cardInnerHorizontal": "bonds-module-scss-module__0QK9YW__cardInnerHorizontal",
  "cardInnerVertical": "bonds-module-scss-module__0QK9YW__cardInnerVertical",
  "cardWrapper": "bonds-module-scss-module__0QK9YW__cardWrapper",
  "countInTab": "bonds-module-scss-module__0QK9YW__countInTab",
  "explanation": "bonds-module-scss-module__0QK9YW__explanation",
  "explanationIcon": "bonds-module-scss-module__0QK9YW__explanationIcon",
  "exportToExcelSpinner": "bonds-module-scss-module__0QK9YW__exportToExcelSpinner",
  "exportToExcelWrapper": "bonds-module-scss-module__0QK9YW__exportToExcelWrapper",
  "filtersButton": "bonds-module-scss-module__0QK9YW__filtersButton",
  "header": "bonds-module-scss-module__0QK9YW__header",
  "headerLabel": "bonds-module-scss-module__0QK9YW__headerLabel",
  "isBlurred": "bonds-module-scss-module__0QK9YW__isBlurred",
  "label": "bonds-module-scss-module__0QK9YW__label",
  "mobileHide": "bonds-module-scss-module__0QK9YW__mobileHide",
  "pageHeaderActions": "bonds-module-scss-module__0QK9YW__pageHeaderActions",
  "pageHeaderSummaryActions": "bonds-module-scss-module__0QK9YW__pageHeaderSummaryActions",
  "pageNavigation": "bonds-module-scss-module__0QK9YW__pageNavigation",
  "searchChartBtnWrapper": "bonds-module-scss-module__0QK9YW__searchChartBtnWrapper",
  "searchFormField": "bonds-module-scss-module__0QK9YW__searchFormField",
  "searchInput": "bonds-module-scss-module__0QK9YW__searchInput",
  "searchInputWrapper": "bonds-module-scss-module__0QK9YW__searchInputWrapper",
  "summaryHeader": "bonds-module-scss-module__0QK9YW__summaryHeader",
  "summaryTabsInfo": "bonds-module-scss-module__0QK9YW__summaryTabsInfo",
  "tabsInfo": "bonds-module-scss-module__0QK9YW__tabsInfo",
});
